<template>
  <div class="resolve-page">
    <section class="resolve-hero">
      <div class="container resolve-hero-inner">
      </div>
    </section>

    <section id="solution" class="resolve-section">
      <div class="container">
        <div class="resolve-title">
          <h2>GPS定位器解决方案</h2>
          <span>GPS LOCATOR SOLUTION</span>
        </div>

        <div class="resolve-tabs" role="tablist" aria-label="解决方案选择">
          <button
            v-for="(item, index) in tabs"
            :id="item.id"
            :key="item.title"
            type="button"
            role="tab"
            :aria-selected="activeTabIndex === index ? 'true' : 'false'"
            :class="{ active: activeTabIndex === index }"
            @click="setActiveTab(index)"
            @mouseenter="setActiveTab(index)"
          >
            <img :src="item.icon" :alt="item.title">
            <span>{{ item.title }}</span>
          </button>
        </div>

        <div class="resolve-case-grid" @mouseleave="hoverResolveCardIndex = 0">
          <article
            v-for="(item, index) in displayedCaseCards"
            :key="item.title"
            class="resolve-case-card"
            :class="{ active: hoverResolveCardIndex === index }"
            @mouseenter="hoverResolveCardIndex = index"
          >
            <div class="resolve-case-image" :class="item.visual">
              <img v-if="item.image" :src="item.image" :alt="item.title">
              <span v-if="item.slogan">{{ item.slogan }}</span>
            </div>
            <div class="resolve-case-body">
              <h3>{{ item.title }}</h3>
              <dl>
                <template v-for="group in item.groups">
                  <dt :key="`${item.title}-${group.title}`">{{ group.title }}</dt>
                  <dd
                    v-for="point in group.points"
                    :key="`${item.title}-${group.title}-${point}`"
                  >
                    {{ point }}
                  </dd>
                </template>
              </dl>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ServicesView',
  data() {
    return {
      activeTabIndex: 0,
      hoverResolveCardIndex: 0,
      tabs: [
        {
          id: 'vehicle',
          icon: require('@/assets/image/resolve1.png'),
          title: '车辆位置追踪'
        },
        {
          id: 'people',
          icon: require('@/assets/image/resolve2.png'),
          title: '智慧人员定位'
        },
        {
          id: 'livestock',
          icon: require('@/assets/image/resolve3.png'),
          title: '畜牧/宠物定位'
        },
        {
          id: 'finance',
          icon: require('@/assets/image/resolve.png'),
          title: '汽车金融风控'
        }
      ],
      caseCards: [
        {
          visual: 'visual-truck',
          title: '讯驰捷运智能配送车辆监管项目',
          groups: [
            { title: '系统架构', points: ['GPS双模车载终端 + 千讯云物流管理平台 + 司机APP'] },
            { title: '功能模块', points: ['实时路径优化（AI动态避开拥堵）', '电子围栏监管（仓库/客户区域自动触发到离提醒）', '司机驾驶评分（急刹、超速行为生成绩效报表）'] }
          ]
        },
        {
          visual: 'visual-taxi',
          title: '一嗨租车安全调度与司乘协同系统',
          groups: [
            { title: '技术亮点', points: ['LBS定位技术（司机、车站乘客发站区域精准匹配）'] },
            { title: '功能模块', points: ['乘客乘车时间窗（预留到站时间误差<10分钟）', '司机行为监控（夜间行驶自动触发后台安全员介入）', '行程偏离预警（路线偏移超500米推送至运营端）'] }
          ]
        },
        {
          visual: 'visual-bike',
          title: '防盗与共享运营一体化方案',
          groups: [
            { title: '实施效益', points: ['经反馈行业共享电单车企业车辆丢失率从8%降至1.2%。'] },
            { title: '功能模块', points: ['智能状态监测（防拆卸报警）', '蓝牙开锁技术（创建电子停车区、社区自动断电）', '电池健康监测（定位+低压传感器预测更换周期）'] }
          ]
        },
        {
          visual: 'visual-fleet',
          title: '温控溯源一体化平台',
          groups: [
            { title: '技术架构', points: ['-70°C ~ +50°C宽温域终端设计，适应疫苗运输等极端场景。'] },
            { title: '功能模块', points: ['多温区监测（每车厢独立温显传感器+定位数据绑定）', '冷机故障预警（温度异常时自动派发维护工单）', 'GSP/HACCP合规模板（一键导出审计所需时间-温度曲线）'] }
          ]
        },
        {
          visual: 'visual-bus',
          title: '乐昌市智慧公交大脑系统',
          groups: [
            { title: '实施效益', points: ['乐昌市公交系统空驶率降低18%，高峰班次准点率达92%。'] },
            { title: '功能模块', points: ['基于乘客流向的智能预调（动态增减班次）', '跨线路联动（突发大客流时调度其他线路车辆支援）', 'P端乘客站内报站'] }
          ]
        },
        {
          visual: 'visual-farm',
          slogan: '让农业更轻松 让生活更美好',
          title: '农业集团研究所精准农业作业云平台',
          groups: [
            { title: '终端配置', points: ['农机专用防水抗震定位器'] },
            { title: '功能模块', points: ['作业轨迹重叠分析（避免重复播种/施肥）', '政府监管接口（定位数据直通同步农机补贴平台）', '碳排放追踪（作业油耗和碳排放异常研判）'] }
          ]
        }
      ],
      vehicleCaseCards: [
        {
          image: require('@/assets/image/resolve1_1.png'),
          title: '讯驰捷运智能配送车辆监管项目',
          groups: [
            { title: '系统架构', points: ['GPS双模车载终端 + 千讯云物流管理平台 + 司机APP'] },
            { title: '功能模块', points: ['实时路径优化（AI动态避开拥堵）', '电子围栏监管（仓库/客户区域自动触发到离提醒）', '司机驾驶评分（急刹、超速行为生成绩效报表）'] }
          ]
        },
        {
          image: require('@/assets/image/resolve1_2.png'),
          title: '一嗨租车安全调度与司乘协同系统',
          groups: [
            { title: '技术亮点', points: ['LBS地理围栏（机场、车站等高发纠纷区域重点监控）'] },
            { title: '功能模块', points: ['乘客端实时地图（预测到达时间误差<1分钟）', '司机行为监测（夜间行车自动触发后台安全员介入）', '行程偏离预警（路线偏移超500米推送客服核查）'] }
          ]
        },
        {
          image: require('@/assets/image/resolve1_3.png'),
          title: '防盗与共享运营一体化方案',
          groups: [
            { title: '实施效益', points: ['经风控统计共享电单车企业车辆丢失率从8%降至1.2%。'] },
            { title: '功能模块', points: ['隐藏式定位器（防拆卸报警）', '蓝牙遥控技术（创建电子停车区、社区自动断电）', '电池健康监测（定位+低压传感器预测更换周期）'] }
          ]
        },
        {
          image: require('@/assets/image/resolve1_4.png'),
          title: '温控溯源一体化平台',
          groups: [
            { title: '技术壁垒', points: ['-70°C ~ +50°C宽温域终端设计，适应疫苗运输等极端场景。'] },
            { title: '功能模块', points: ['多温区监测（每车厢独立温显传感器+定位数据绑定）', '冷机故障预警（温度异常时自动通知最近维修点）', 'GSP/HACCP合规模板（一键导出审计所需时间-温度曲线）'] }
          ]
        },
        {
          image: require('@/assets/image/resolve1_5.png'),
          title: '乐昌市智慧公交大脑系统',
          groups: [
            { title: '实施效益', points: ['乐昌市公交系统空驶率降低18%，高峰期准点率达92%'] },
            { title: '功能模块', points: ['基于实时定位的客流预测（自动增减班次）', '跨线路联动（突发大客流时调度其他线路车辆支援）', 'P端乘客站内报站'] }
          ]
        },
        {
          image: require('@/assets/image/resolve1_6.png'),
          title: '农业集团研究所精准农业作业云平台',
          groups: [
            { title: '终端配置', points: ['农机专用防水抗震定位器'] },
            { title: '功能模块', points: ['作业轨迹重叠分析（避免重复播种/施肥）', '政府监管接口（定位数据直连同步农机补贴平台）', '燃油偷盗预警（作业时间和油耗异常研判报警）'] }
          ]
        },
        {
          image: require('@/assets/image/resolve1_7.png'),
          title: '资产风控与用户体验升级方案',
          groups: [
            { title: '技术亮点', points: ['与征信系统对接，实现风险用户自动拦截。'] },
            { title: '功能模块', points: ['自助取还车（蓝牙定位解锁车辆）', '违章预警（接入交管区前APP实时提醒）', '信用围栏（限制高危用户行驶区域）'] }
          ]
        },
        {
          image: require('@/assets/image/resolve1_8.png'),
          title: '智慧城市管家系统',
          groups: [
            { title: '实施效益', points: ['某海环卫成本年节省超800万元'] },
            { title: '功能模块', points: ['AI路径规划，基于历史垃圾量数据生成动态路线', '突发任务响应（路面污染事件自动调度最近车辆）', '实时查看洒水车/清运车位置'] }
          ]
        },
        {
          image: require('@/assets/image/resolve1_9.png'),
          title: '家校协同守护平台',
          groups: [
            { title: '终端配置', points: ['高精度车载定位器'] },
            { title: '功能模块', points: ['学生上下车通知（RFID学生卡绑定定位器提醒）', '超员报警（人数超限时车辆限速）', '应急逃生指引（事故时自动推送最近逃生门位置）'] }
          ]
        }
      ],
      peopleCaseCards: [
        {
          image: require('@/assets/image/resolve2_1.png'),
          title: '老人健康监护',
          groups: [
            { title: '终端设计', points: ['轻便定位器（支持实时定位、一键导航）'] },
            { title: '功能模块', points: ['电子围栏（老人离开安全区域时自动通知护工）', '健康数据异常预警（长时间静止触发报警）', '低功耗设计（续航7天，支持无线充电）'] }
          ]
        },
        {
          image: require('@/assets/image/resolve2_2.png'),
          title: '儿童智能定位器',
          groups: [
            { title: '解决痛点', points: ['孩子上下学途中走失或遇险意外，无法实时掌握孩子位置'] },
            { title: '风控流程', points: ['GPS+北斗+LBS三重定位，支持室内外无缝切换', '家长可设置安全区域，孩子超出范围时自动报警', '孩子长按按钮可发送求救信号，APP实时接收位置信息'] }
          ]
        },
        {
          image: require('@/assets/image/resolve2_3.png'),
          title: '建筑工地人员安全管理',
          groups: [
            { title: '硬件配置', points: ['佩戴式定位手环'] },
            { title: '功能模块', points: ['危险区域电子围栏（超范围作业自动提醒）', '实时定位+轨迹回放（事故后快速锁定被困人员位置）', 'GPS+蓝牙信标+UWB技术'] }
          ]
        },
        {
          image: require('@/assets/image/resolve2_4.png'),
          title: '物流园区人员调度优化',
          groups: [
            { title: '软硬件方案', points: ['定位器+调度管理平台+移动端APP'] },
            { title: '风控流程', points: ['实时人员分布热力图（动态调配空闲工人）', '与WMS（仓储管理系统）数据打通，实现任务-人员智能匹配'] }
          ]
        },
        {
          image: require('@/assets/image/resolve2_5.png'),
          title: '医院医护人员调度管理',
          groups: [
            { title: '硬件配置', points: ['医护工牌式定位器'] },
            { title: '功能模块', points: ['实时位置共享（急诊室可快速调派最近医护人员）', '工作量统计（生成医护人员活动轨迹与任务负荷报表）', '与HIS（医院信息系统）数据打通，实现任务智能分配'] }
          ]
        },
        {
          image: require('@/assets/image/resolve2_6.png'),
          title: '矿山作业人员安全保障',
          groups: [
            { title: '硬件配置', points: ['矿用防爆定位终端'] },
            { title: '功能模块', points: ['事故后快速定位（支持地下GPS信号弱环境下的精准定位）', '危险区域预警', '与矿山安全监测系统联动（实时推送环境风险数据）'] }
          ]
        }
      ],
      livestockCaseCards: [
        {
          image: require('@/assets/image/resolve3_1.png'),
          title: '牧场牛群放牧智能化管理',
          groups: [
            { title: '终端设计', points: ['牛耳扣式定位器（防啃咬材质、太阳能充电）'] },
            { title: '功能模块', points: ['电子围栏（超出牧场范围自动报警）', '牛群聚集分析（识别发情期或疾病传播风险）', '太阳能充电+低功耗设计，适应野外环境'] }
          ]
        },
        {
          image: require('@/assets/image/resolve3_2.png'),
          title: '宠物猫狗防走失',
          groups: [
            { title: '终端设计', points: ['宠物智能项圈式定位器'] },
            { title: '核心功能', points: ['实时定位与轨迹回放', '社交功能（附近宠物位置共享）', '电训功能，轻微电流，指令训练'] }
          ]
        },
        {
          image: require('@/assets/image/resolve3_3.png'),
          title: '野生动物迁徙研究与反盗猎',
          groups: [
            { title: '终端设计', points: ['微型卫星定位器（植入皮下，续航2年）'] },
            { title: '功能模块', points: ['迁徙轨迹大数据分析', '异常位置报警（疑似盗猎陷阱区域）', '卫星通信（无地面网络覆盖仍可传输数据）'] }
          ]
        },
        {
          image: require('@/assets/image/resolve3_4.png'),
          title: '羊群防丢失与智能分群',
          groups: [
            { title: '软硬件方案', points: ['羊耳标式定位器+调度管理平台+移动端APP'] },
            { title: '功能设计', points: ['羊群动态热力图（自动识别离散个体）', '分群指令推送（通过声光信号引导头羊）', '实时定位于轨迹回放'] }
          ]
        },
        {
          image: require('@/assets/image/resolve3_5.png'),
          title: '水产养殖定位追踪',
          groups: [
            { title: '终端设计', points: ['防水定位浮标'] },
            { title: '功能模块', points: ['网箱位置实时监控', '洋流预警（偏离预设坐标自动报警）', '电子围栏，实时定位'] }
          ]
        },
        {
          image: require('@/assets/image/resolve3_6.png'),
          title: '赛马训练与健康管理',
          groups: [
            { title: '终端设计', points: ['马鞍嵌入式定位器'] },
            { title: '功能模块', points: ['实时速度、步频监测', '肌肉疲劳预警（通过每日里程分析）', '训练数据对比（生成最佳赛道策略）'] }
          ]
        }
      ]
    }
  },
  computed: {
    displayedCaseCards() {
      if (this.activeTabIndex === 0) return this.vehicleCaseCards
      if (this.activeTabIndex === 1) return this.peopleCaseCards
      if (this.activeTabIndex === 2) return this.livestockCaseCards
      return this.caseCards
    }
  },
  watch: {
    '$route.hash': {
      immediate: true,
      handler() {
        this.activateTabFromHash()
      }
    }
  },
  methods: {
    setActiveTab(index) {
      if (this.activeTabIndex !== index) {
        this.hoverResolveCardIndex = 0
      }
      this.activeTabIndex = index
    },
    activateTabFromHash() {
      const id = (this.$route.hash || '').replace('#', '')
      const index = this.tabs.findIndex(item => item.id === id)

      if (index >= 0) {
        this.setActiveTab(index)
      }
    }
  }
}
</script>
